import YoutubePlayerChunk from './YoutubePlayerChunk/YoutubePlayerChunk';
import ThirdPartyScriptsChunk from './ThirdPartyScripts/ThirdPartyScripts';
import PagePartsChunk from './PagePartsChunk/PagePartsChunk';
import ModalConnectionChunk from './ModalConnectionChunk/ModalConnectionChunk';

/*
 * Document Ready
 * */
export default class InitChunks {
  constructor() {
    window.addEventListener(
      'load',
      () => {
        // Add Youtube Player in page
        new YoutubePlayerChunk();

        // Add Third Party Scripts
        new ThirdPartyScriptsChunk();

        // Add Page Parts
        new PagePartsChunk();

        // Add Modal Connection
        new ModalConnectionChunk();
      },
      { passive: true }
    );
  }
}
